export default function( defaults ){

	defaults.on.init_complete = function(){

		if( !this.params.effect.handlePointerMove )
			return false;

		let handler = {
			consumer: this,
			initial: {x: null, y: null},
			handleEvent: function( e ){

				if( e.type == 'mousedown' ){
					this.initial.x = e.pageX;
					this.initial.y = e.pageY;

					document.addEventListener('mousemove', this);
					document.addEventListener('mouseup', this);

					if( this.consumer.params.effect.handlePointerEmployment )
						this.consumer.params.effect.handlePointerEmployment( e )


				} else if( e.type == 'mouseup' ){

					document.removeEventListener('mousemove', this);
					document.removeEventListener('mouseup', this);

					if( this.consumer.params.effect.handlePointerRelease ){
						let promise = this.consumer.params.effect.handlePointerRelease( e )

						if( promise ){
							promise.then(
								( current ) => {

									this.consumer.current = current;
									this.consumer.index = [...this.consumer.root.children].indexOf(current);
									this.consumer.applyEvents('swap_end', 'finalcarousel', [ this.consumer.current ]);

								},
								( err ) => {
								}
							);

						} else{
							this.consumer.applyEvents('swap_end', 'finalcarousel', [ this.consumer.current ]);
						}

					}

				} else if( e.type == 'mousemove' ){

					e.target.addEventListener('click', this);

					this.consumer.params.effect.handlePointerMove(
						this.initial,
						{ x: e.pageX, y: e.pageY }
					)

				} else if( e.type == 'click' ){

					e.target.removeEventListener('click', this);
					if( e.pageX !== this.initial.x )
						e.stopImmediatePropagation();

				}

				e.preventDefault();
				
			}

			
		}

		this.root.addEventListener( 'mousedown', handler);

	}

}